import 'bootstrap/dist/css/bootstrap.css';
import SearchBar from './components/SearchInput'
import FindButton from './components/FindButton'
import TableResult from './components/TableResult'
import logo from './logo.jpg'
import { Component } from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Selected from './components/Selected';
import loadingPng from './Spin-1s-200px.gif'
class Home extends Component{

state = {
  tracks1Home: [],
  tracks2Home: [],
  ID1home: "",
  ID2home: "",
  imgSx: "",
  nameSx: "",
  imgDx: "",
  nameDx: "",
  loadingSx: false,
  loadingDx: false,
  footerFixed: true,
  tableIsVisible: false
}

handleArtistSet = (albums, side, id, name, img) => {
    if(side == "sx"){
      //setTracks1(albums)
      //ReactDOM.unmountComponentAtNode(FeatFound)
     this.setState({tracks1Home: albums,
                    ID1home: id,
                    nameSx: name,
                    imgSx: img})
     //console.log("tracks1 in home", this.state.tracks1Home)
     //console.log("tracks2 inh", this.state.tracks2Home)
    } else {
      //setTracks2(albums)
     // ReactDOM.unmountComponentAtNode(FeatFound)
      this.setState({tracks2Home: albums,
                    ID2home: id,
                    nameDx: name,
                    imgDx: img})
      //console.log("tracks1 inh", this.state.tracks1Home)
      //console.log("tracks2 inh", this.state.tracks2Home)
    }

    console.log("new artist")
    
  };

  handleFooterPosition = () => {
    this.setState({ footerFixed: false});
  };

  componentDidMount() {
    // Set a timeout to change the state after a delay (e.g., 3 seconds)
    //window.addEventListener('scroll', this.handleScroll);
     // Adjust the delay as needed (e.g., 3000 milliseconds = 3 seconds)
  }

  componentWillUnmount() {
    //window.removeEventListener('scroll', this.handleScroll);
    //clearTimeout(this.timeout); // Clear the timeout if the component unmounts
  }

  setFooterPosition = () => {
    this.setState({footerFixed: true})
  }

  handleFinalLoading = (side, value) => {
    if(side == "sx"){
      this.setState({loadingSx: value})
    } else {
      this.setState({loadingDx: value})
    }

    
  }


render(){
  return(
  <div style={{display: "grid"}}>
      <Navbar/>

      <div class="row" style={{textAlign: "center", marginTop: "20px"}}>
 
    <div class="col" >
    <h1>FeatFinder Classic Mode</h1>
    <p>Select two artists to find out if they ever made a song together, then play it on Spotify!</p>
    <p><i>Tip: Select the same artist on both sides to check out the full discography!</i></p>
    
    </div>
 
  </div>
      <div class="container-md">
<div class="row" style={{textAlign: "center", marginTop: "20px"}}>
    <div class="col-3">
      <SearchBar side={"sx"} onFinalArtistSet={this.handleArtistSet} onFinalLoadingSet={this.handleFinalLoading}/>
    </div>
    <div class="col">
    </div>
    <div class="col-3">
    <SearchBar side={"dx"} onFinalArtistSet={this.handleArtistSet} onFinalLoadingSet={this.handleFinalLoading}/>
    </div>
  </div>
  <div class="row" style={{textAlign: "center", marginTop: "20px"}}>
    <div class="col-3">
    {
      this.state.nameSx != "" ? (
        <Selected img={this.state.imgSx} name={this.state.nameSx} isLoading={this.state.loadingSx}/>
      ): this.state.loadingSx == true ? (<img
        src={loadingPng}
        alt={""}
        style={{ width: '20vh', height: '20vh' }} // Imposta la larghezza desiderata in pixel
    />) : ("")
     }
    </div>
    <div class="col">
    </div>
    <div class="col-3">
     {
      this.state.nameDx != "" ? (
        <Selected img={this.state.imgDx} name={this.state.nameDx} isLoading={this.state.loadingSx}/>
      ): this.state.loadingDx == true ? (<img
        src={loadingPng}
        alt={""}
        style={{ width: '20vh', height: '20vh' }} // Imposta la larghezza desiderata in pixel
    />) : ("")
     }
    </div>
  </div>
  <div class="row" style={{textAlign: "center", marginTop: "20px"}}>

    <div class="col">
    <input type="submit" value="Click here to reset the values" class="btn btn-success" onClick={() => {window.location.reload()}} style={{ background: '#D9E724', borderColor: '#8b008b', color:'black', float: "center", marginBottom: "5px"}}/>
    <FindButton tracksSx={this.state.tracks1Home} tracksDx={this.state.tracks2Home} idSx={this.state.ID1home} idDx={this.state.ID2home} onFinalFooterSet={this.handleFooterPosition} onFooter={this.setFooterPosition}/>
    </div>
   
  </div>
  
</div>

    </div>


)

}}

export default Home;